/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiscreditedProvidersDialogAliases {
  AVATAR_USER = 'avatar-user',
  FIELD_DT_END_PROVIDER = 'field-dtEndProvider',
  FIELD_DT_PUBLISHED = 'field-dtPublished',
  FIELD_NAME = 'field-name',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPE_D = 'hpms-custom-card-content-collape-D',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPE_S = 'hpms-custom-card-content-collape-S',
  HPMS_DYNAMIC_CONTENT_D = 'hpms-dynamic-content-D',
  HPMS_DYNAMIC_CONTENT_S = 'hpms-dynamic-content-S',
  LAYOUT_MAIN = 'layout-main',
  MAPPER_USER = 'mapper-user',
  TEXT_DT_END_PROVIDER = 'text-dtEndProvider',
  TEXT_DT_PUBLISHED = 'text-dtPublished',
}
export { DiscreditedProvidersDialogAliases };
